import { checkIsInternal } from '@src/utility/createStorage';
import HttpService from '@src/utility/httpService';
import { config } from '@uhg-abyss/web/tools/config';
import { CLAIMS_REPORTING_API_URLS } from './apiUrlConstants';

const _httpService = new HttpService();

// Set base URL at request time (not module load time) to ensure sessionStorage is populated
const setBaseUrl = () => {
  if (checkIsInternal()) {
    _httpService.setBaseURL(config('BULK_PROCESSING'));
  } else {
    _httpService.setBaseURL(config('API_DOMAIN_EXTERNAL'));
  }
};

export const saveClaimsReportParameters = async (payload: any) => {
  setBaseUrl();
  try {
    const response = await _httpService.push(CLAIMS_REPORTING_API_URLS.SAVE_CLAIMS_REPORTING, payload) as any;
    if (response.StatusCode !== 201 && response.StatusCode !== 200) {
      throw new Error(response.Message || 'Failed to save claims reporting parameters');
    }
    return response;
  } catch (error) {
    console.error('Error saving claims reporting parameters:', error);
    throw error;
  }
};

export const generatePreviewClaimsReport = async (payload: any) => {
  setBaseUrl();
  try {
    const response  = await _httpService.push(CLAIMS_REPORTING_API_URLS.GENERATE_PREVIEW_REPORT, payload) as any;
    if (response.StatusCode !== 200) {
      throw new Error(response.Message || 'Failed to generate preview claims report');
    }
    return response;
  } catch (error) {
    console.error('Error generating preview claims report:', error);
    throw error;
  }
};

export const fetchSavedClaimsReport = async (payload: any) => {
  setBaseUrl();
   try {
    const response  = await _httpService.push(CLAIMS_REPORTING_API_URLS.FETCH_CLAIMS_REPORTING_LIST, payload) as any;
    console.info("API Response for Fetching Saved Claims Reports:", response);
    if (response.StatusCode !== 200) {
      throw new Error(response.Message || 'Failed to fetch saved claims reports');
    }
    return response;
  } catch (error) {
    console.error('Error fetching saved claims reports:', error);
    throw error;
  }
}

export const removeClaimsReport = async (reportId: string) => {
  setBaseUrl();
  try {
    const response  = await _httpService.remove(CLAIMS_REPORTING_API_URLS.REMOVE_CLAIMS_REPORT(reportId)) as any;
    console.info("API Response for Removing Claims Report:", response);
    if (response.StatusCode !== 200) {
      throw new Error(response.Message || 'Failed to remove claims report');
    }
    return response;
  } catch (error) {
    console.error('Error removing claims report:', error);
    throw error;
  }
}

export const generateConversation = async (payload: any) => {
  setBaseUrl();
  try {
    const response  = await _httpService.push(CLAIMS_REPORTING_API_URLS.GENERATE_CONVERSATION, payload) as any;
    if (response.StatusCode !== 200) {
      throw new Error(response.Message || 'Failed to generate conversation');
    }
    return response;
  } catch (error) {
    console.error('Error generating conversation:', error);
    throw error;
  }
};

export const fetchSingleClaimsReport = async (payload: any) => {
  setBaseUrl();
  try {
    const response  = await _httpService.push(CLAIMS_REPORTING_API_URLS.FETCH_SINGLE_CLAIMS_REPORT, payload) as any;
    if (response.StatusCode !== 200) {
      throw new Error(response.Message || 'Failed to fetch single claims report');
    }
    return response;
  } catch (error) {
    console.error('Error fetching single claims report:', error);
    throw error;
  }
}

export const fetchClaimsReportPreviewByJobId = async (jobId: string) => {
  setBaseUrl();
  try {
    const response  = await _httpService.get(CLAIMS_REPORTING_API_URLS.FETCH_CLAIMS_REPORT_PREVIEW_BY_JOB_ID(jobId)) as any;
    if (response.StatusCode !== 200) {
      throw new Error(response.Message || 'Failed to fetch claims report preview');
    }
    return response;
  } catch (error) {
    console.error('Error fetching claims report preview:', error);
    throw error;
  }
}

export const fetchClaimsReportingDataByAttachmentID = async (conversationId: string, messageId: string, attachmentId: string) => {
  setBaseUrl();
  try {
    const response  = await _httpService.push(CLAIMS_REPORTING_API_URLS.FETCH_CLAIMS_REPORTING_BY_ATTACHMENT_ID, { conversationId, messageId, attachmentId }) as any;
    if (response.StatusCode !== 200) {
      throw new Error(response.Message || 'Failed to fetch claims reporting data by attachment ID');
    }
    return response;
  }
  catch (error) {
    console.error('Error fetching claims reporting data by attachment ID:', error);
    throw error;
  }
}

export const updateClaimReportParameters = async (payload: any) => {
  setBaseUrl();
  try {
    const response  = await _httpService.push(CLAIMS_REPORTING_API_URLS.UPDATE_CLAIMS_REPORT_PARAMETERS, payload) as any;
    if (response.StatusCode !== 200) {
      throw new Error(response.Message || 'Failed to update claims report parameters');
    }
    return response;
  }
  catch (error) {
    console.error('Error updating claims report parameters:', error);
    throw error;
  }
}
